import { useOpenBaas } from "../Context/SdkBaasOpen";
import useIsLogin from "../hooks/useIsLogin";

function useMagicLink() {
  const { uri, setAccessToken, setRefreshToken } = useOpenBaas();
  const { setIsLogin } = useIsLogin();
  const handleGenerateCode = async (email: string, route?: string) => {
    const completeuri = `${uri}${route ?? "/v1/auth/magic-link"}`;
    await fetch(completeuri, {
      method: "PUT",
      body: JSON.stringify({ email, created: new Date() }),
    });
  };
  const handleConfirmationCode = async (
    email: string,
    confirmationCode: string,
    route?: string
  ) => {
    const completeuri = `${uri}${route ?? "/v1/auth/magic-link"}`;
    const res = await fetch(completeuri, {
      method: "POST",
      body: JSON.stringify({ email, confirmationCode, created: new Date() }),
    });
    const body = await res.json();
    if (body) {
      setAccessToken(body.accessToken);
      setRefreshToken(body.refreshToken);
      setIsLogin(true);
    }
  };
  return { handleGenerateCode, handleConfirmationCode };
}
export default useMagicLink;
